module.exports = __webpack_public_path__ + "static/media/uy.3b6078d1.svg";